import { AnswerTypeSchema, MedicalDeclarationQuestionsResponse } from '@shory-health-individual/customer-api';
import { AnswerTypes } from './types';

type MappedAnswer = Record<string, AnswerTypeSchema>;
type MappedQuestion = Record<string, MappedAnswer>;
type MappedMember = Record<string, MappedQuestion>;

export const getMappedAnswers = (declarationQuestions: MedicalDeclarationQuestionsResponse): MappedMember => {
	return declarationQuestions.reduce<MappedMember>((acc, curr) => {
		acc[curr.memberId] = curr?.questions?.reduce?.<MappedQuestion>((queAcc, question) => {
			queAcc[question.id] = question?.answers?.reduce<MappedAnswer>((ansAcc, answer) => {
				const answerKey = !answer.isCustomAnswer ? answer.answerText : 'CUSTOM_ANSWER';

				ansAcc[answerKey] = answer;

				return ansAcc;
			}, {});

			return queAcc;
		}, {});

		return acc;
	}, {});
};

type Props = {
	declarationQuestions: MedicalDeclarationQuestionsResponse;
};

function useDeclarationAnswers(props: Props) {
	const { declarationQuestions } = props;
	const mappedAnswers = getMappedAnswers(declarationQuestions);

	const getAnswerIdFromSavedAnswer = (memberId: string, questionId: number, answer: AnswerTypes) => {
		const answerMap = mappedAnswers?.[memberId]?.[questionId] ?? {};

		if (typeof answer === 'string') {
			return answerMap?.['CUSTOM_ANSWER']?.id;
		}

		return answerMap?.[String(answer)]?.id;
	};

	return { getAnswerIdFromSavedAnswer };
}

export default useDeclarationAnswers;
